import moment from "moment";

export const getBuildDate = (epoch) => {
  const buildDate = moment(epoch).format("DD-MM-YYYY HH:MM");
  return buildDate;
};

const LOGIN_ROUTE_KEY = 'preferredLoginRoute';

export const setPreferredLoginRoute = route => {
  window.localStorage.setItem(LOGIN_ROUTE_KEY, route);
};

export const getPreferredLoginPath = () => {
  const route = window.localStorage.getItem(LOGIN_ROUTE_KEY);
  return route === 'logino' ? 'logino' : 'login';
};